import { PatientResponseIdentifier } from '@dermloop/static-values';
import { Type } from 'class-transformer';
import { IsDate, IsEnum, IsNotEmpty, IsString, IsUUID } from 'class-validator';
import { BaseDto } from '../base.dto';

export interface PatientResponseHealthRecordDto {
  firstName?: string;
  lastName?: string;
  birthDate?: Date;
}

export interface PatientResponseTeleAssessmentDto {
  assessmentDate?: string | Date;
  diagnosisName?: string;
}

export interface PatientResponseMedicalUnitDto {
  name: string;
  phoneNumber?: string;
  sharedEmail?: string;
}

export type PatientResponseDto =
  | NonExpiredPatientResponseDto
  | ExpiredPatientResponseDto;

interface NonExpiredPatientResponseDto extends BaseDto, BasePatientResponseDto {
  healthRecordId: string;
  teleAssessmentId: string;
  identifierType: PatientResponseIdentifier;
  expired: false;
  note: string;
  healthRecord?: PatientResponseHealthRecordDto;
  teleAssessment?: PatientResponseTeleAssessmentDto;
}

interface ExpiredPatientResponseDto extends BasePatientResponseDto {
  expired: true;
}

interface BasePatientResponseDto {
  expiryDate: Date;
  createdByMedicalUnitId: string;
  medicalUnit?: PatientResponseMedicalUnitDto;
}

export class CreatePatientResponseDto {
  @IsNotEmpty()
  @IsString()
  @IsUUID()
  healthRecordId: string;

  @IsNotEmpty()
  @IsString()
  @IsUUID()
  teleAssessmentId: string;

  @IsNotEmpty()
  @IsEnum(PatientResponseIdentifier)
  identifierType: PatientResponseIdentifier;

  @IsNotEmpty()
  @IsDate()
  @Type(() => Date)
  expiryDate: Date;

  @IsNotEmpty()
  @IsString()
  note: string;
}

export class QueryParamsPatientResponseDto {
  @IsNotEmpty()
  @IsEnum(PatientResponseIdentifier)
  identifierType: PatientResponseIdentifier;

  @IsNotEmpty()
  @IsString()
  challenge: string;

  @IsNotEmpty()
  @IsString()
  identifier: string;
}
